import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFloatplaneComponent } from './simple-icons-floatplane.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFloatplaneComponent ],
    exports:      [ SimpleIconsFloatplaneComponent ],
    bootstrap:    []
})
export class SimpleIconsFloatplaneModule {}
